import { render, staticRenderFns } from "./GeneralIntegrationSettings.vue?vue&type=template&id=6713783b&scoped=true&"
import script from "./GeneralIntegrationSettings.vue?vue&type=script&lang=js&"
export * from "./GeneralIntegrationSettings.vue?vue&type=script&lang=js&"
import style0 from "./GeneralIntegrationSettings.vue?vue&type=style&index=0&id=6713783b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6713783b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6713783b')) {
      api.createRecord('6713783b', component.options)
    } else {
      api.reload('6713783b', component.options)
    }
    module.hot.accept("./GeneralIntegrationSettings.vue?vue&type=template&id=6713783b&scoped=true&", function () {
      api.rerender('6713783b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/settings/GeneralIntegrationSettings.vue"
export default component.exports